import { useRouter } from "next/router";
import { useState } from "react";
import api from "shared/infra/services/api";

const useCourse = () => {
  const router = useRouter();
  const course_slug = router.query.course_slug;
  const module_slug = router.query.module_slug;
  const lesson_slug = router.query.lesson_slug;
  const [userToken, setUserToken] = useState();

  const requestCourse = async () => {
    const response = await api.get(`course/${course_slug}`, {
      headers: { Authorization: `Berear + ${userToken}` },
    });
    return response.data.data;
  };

  const requestsLessonsAndModules = async () => {
    const response = await api.get(
      `course/modules/lessons/${course_slug}/all`,
      { headers: { Authorization: `Berear + ${userToken}` } },
    );
    return response.data.data;
  };

  const requestLessons = async () => {
    const response = await api.get(
      `course/${course_slug}/${module_slug}/${lesson_slug}`,
      { headers: { Authorization: `Bearer+ ${userToken}` } },

    );
    return response.data.data;
  };

  const saveCourseInStorage = (course) => {
    sessionStorage.setItem("courses_landing", JSON.stringify(course));
  };

  const saveLessonsInStorage = (lessons) => {
    sessionStorage.setItem("lessons", JSON.stringify(lessons));
  };

  const saveLessonsAndModules = (lessonsAndModules) => {
    sessionStorage.setItem("modules", JSON.stringify(lessonsAndModules));
  };

  const getCourses = async () => {
    try {
      const course = await requestCourse();

      saveCourseInStorage([course]);
      
      return course;
    } catch (error) {
      throw new Error("[Coursers :: getCourses] - Failed to get courses", error);
    }
  };

  const getLessonsAndModules = async () => {
    try {
      const lessonsAndModules = await requestsLessonsAndModules();

      saveLessonsAndModules([{ title: course_slug, data: lessonsAndModules }]);

      return lessonsAndModules;
    } catch (error) {
      throw new Error("[Coursers :: getLessonsAndModules] - Failed to get lessons and modules", error);
    }
  };

  const getLessons = async (ignoreCache?: boolean) => {
    try {
      const response = await requestLessons();
      saveLessonsInStorage([
        {
          lesson: `${course_slug}-${module_slug}-${lesson_slug}`,
          data: response,
        },
      ]);

      return response;
    } catch (error) {
      throw new Error("[Coursers :: getLessons] - Failed to get lessons", error);
    }
  };

  return { getCourses, getLessons, getLessonsAndModules, setUserToken };
};

export default useCourse;
